<script>
import { mapGetters } from "vuex";
export default {
  name: "stacked",

  computed: {
    ...mapGetters({
      stackedOffers: "stackedOffers",
      offers: "offers",
      channel: "channel",
      visitor: "visitor",
      thanksUrl: "thanksUrl",
    }),

    user() {
      return this.visitor.subscription || {};
    }
  },

  watch: {
    offers: {
      handler() {
        this.stackedOffers.forEach(x => {
          this.$set(this.model, x.id, true);
        });
      },
      immediate: true
    }
  },

  methods: {
    getField(key) {
      if (this.user && this.user.fields) {
        for (let i = 0; i < this.user.fields.length; ++i) {
          const field = this.user.fields[i];
          if (field.name == key) {
            return field.pivot.value;
          }
        }
      }
    },

    next() {
      if (this.offers.length == 0) {
        this.$router.replace(this.thanksUrl);
      } else {
        this.$router.replace(this.offers[0].url);
      }
    },

    selectAll() {
      const newModel = {};
      this.stackedOffers.forEach(el => {
        newModel[el.id] = true;
      });
      this.$set(this, "model", newModel);
    },

    signup()
    {
        this.$store.dispatch('activateAllStacked', this.model).then(() => {
            this.next()
        })
    },
  },

  data() {
    return {
      model: {}
    };
  }
};
</script>

<template>
  <section class="stacked-offer-page">
    <section class="heading text-center">
      <div class="logo-container">
        <logo red></logo>
      </div>

      <figure class="greeting" v-if="getField('first_name')">
        <i class="fas fa-piggy-bank"></i>
        {{ getField('first_name') }}, we have some exclusive offers just for you! 
      </figure>
    </section>

    <section class="offers">
      <stacked-offer
        v-for="offer in stackedOffers"
        :key="offer.id"
        :offer="offer"
        v-model="model[offer.id]"
      ></stacked-offer>
    </section>

    <section class="bottom">
      <div
        class="selected text-center mb-4 d-flex justify-content-center"
        style="--checkbox-color: var(--color);"
        @click="selectAll"
        v-if="false"
      >
        <checkmark :value="true" readonly>Select All</checkmark>
      </div>
      <block-button
        class="mb-5 text-uppercase"
        big
        @click="signup"
        :class="{ 'selected': Object.keys(model).length != 0 }"
      >
        <template v-if="Object.keys(model).length == 0">Skip</template>
        <template v-else>Activate Offers</template>
      </block-button>
      <p>
        By signing up, I confirm that I want to recieve promotional emails and special offers from the selected vendors and their affiliates, including the specific offers described above.
      </p>

      <p>
        For mor information read
        <a href="http://loverly.test.webandmore.hu/privacy">Data Use Policy</a> and
        <a href="http://loverly.test.webandmore.hu/terms">Terms of Use</a>
      </p>
    </section>
  </section>
</template>

<style lang="scss">
.stacked-offer-page {
  .heading {
    .logo-container {
      margin: 22px 0;
    }

    .greeting {
      font-family: "ProximaNova";
      background-color: var(--color);
      max-width: 480px;
      margin: 0 auto 40px;
      padding: 12px;
      color: white;
      border-radius: 3px;
      font-weight: bold;
      i {
        margin-right: 0.4em;
      }
    }
  }

  .offers {
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    align-content: cetner;
    flex-wrap: wrap;
    flex-flow: row wrap;
    max-width: 1100px;

    @media screen and (max-width: 1100px) {
      max-width: 480px;
    }

    @media screen and (max-width: 560px) {
      max-width: 320px;
    }
  }

  .bottom {
    text-align: center;
    max-width: 540px;
    margin: 55px auto;
    display: flex;
    flex-direction: column;
    p {
      font-family: "ProximaNova";
      font-size: 14px;
      color: #808080;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/stacked/Stacked.vue